<template>
  <div v-if="!atividadeSelecionada" class="main-atv">
    <Breadcrumb v-if="!acaoId" :items="breadcrumbItems" />

    <div v-if="!acaoId" class="header-menu-atividades">
      <h2 class="titulo-pagina">Atividades de Extensão</h2>

      <div class="header-actions">
        <FiltrosComponent :isCoordenador="isCoordenador" nomeTela="atividade" :filtrosIniciais="filtrosSelecionados"
          @pesquisar="executarBusca" />
      </div>
    </div>

    <FiltrosComponent v-else :isCoordenador="isCoordenador" nomeTela="atividade" :filtrosIniciais="filtrosSelecionados"
      @pesquisar="executarBusca" />
  </div>

  <div id="atividades" class="atividades-grid">
    <template v-if="!isLoading">
      <AtividadesCard v-for="atividade in atividades" :key="atividade.id" :atividade="atividade"
        :isCoordenador="isCoordenador" />
    </template>
  </div>

  <AvisoListagem v-if="!isLoading && atividades.length === 0">
    Nenhuma atividade encontrada
  </AvisoListagem>

  <Carregamento v-if="isLoading" />

  <PaginacaoComponent :total-paginas="totalPages" @mudar-pagina="carregarPagina" />
</template>

<script setup>
import { computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router";

import PaginacaoComponent from "@/components/common/paginacaoComponent.vue";
import Carregamento from "@/components/common/Carregamento.vue";
import FiltrosComponent from "@/components/common/FiltrosComponent.vue";
import Breadcrumb from "@/components/common/Breadcrumb.vue";
import AvisoListagem from "../common/AvisoListagem.vue";

import AtividadesCard from "./AtividadesCard.vue";
import { useAtividades } from "@/composables/useAtividades.js";

const props = defineProps({
  isAtiva: Boolean,
  isCoordenador: Boolean,
  acaoId: String,
});

defineEmits(["paginaAberta"]);

const route = useRoute();
const router = useRouter();

const {
  atividades,
  isLoading,
  totalPages,
  fetchAtividadesComFiltros,
} = useAtividades();

const breadcrumbItems = [
  { label: "Início", to: "/" },
  { label: "Atividades", to: "/atividades" },
];

const filtrosSelecionados = computed(() => {
  const cat = route.query.categorias || route.query.categoria;
  return {
    status: route.query.status || "",
    modalidade: route.query.modalidade || "",
    tipo: route.query.tipo || "",
    categorias: cat
      ? Array.isArray(cat)
        ? cat
        : String(cat).split(",").filter(Boolean)
      : [],
    unidadeId: route.query.unidadeId || null,
    busca: route.query.q || "",
  };
});

function executarBusca(termo) {
  const query = { ...route.query };

  if (termo?.trim()) {
    query.q = termo.trim();
  } else {
    delete query.q;
  }

  delete query.page;

  router.push({ query });
}

function carregarPagina(pagina) {
  router.push({
    query: {
      ...route.query,
      page: pagina,
    },
  });
}

watch(
  [() => route.query, () => props.acaoId],
  ([query]) => {
    const page = Number(query?.page) || 0;

    fetchAtividadesComFiltros(
      page,
      6,
      filtrosSelecionados.value,
      props.acaoId || null
    );
  },
  { immediate: true }
);
</script>

<style scoped>
.main-atv {
  width: 100%;
}

/* Cabeçalho */
.header-menu-atividades {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;

  width: 100%;
  margin-bottom: 24px;
  padding-bottom: 15px;

  border-bottom: 1px solid lightgray;
}

.titulo-pagina {
  margin: 0;
  padding: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  flex-wrap: wrap;
}

.header-actions :deep(.barra-acoes) {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  gap: 16px !important;

  width: auto !important;
  margin: 0 !important;
  padding: 0 !important;

  border-bottom: none !important;
}

/* Lista de atividades (inspirado no menu de vagas) */
#atividades,
.atividades-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  width: 100%;
}

/* Responsividade */
@media (max-width: 900px) {

  #atividades,
  .atividades-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 600px) {
  .header-menu-atividades {
    align-items: flex-start;
  }

  .header-actions {
    width: 100%;
    justify-content: flex-start;
  }
}
</style>
